import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { AutocompleteResult } from '../../../models/autocomplete-result';

import { DocumentTypeSearchService } from '../../../services/documents/document-type-search.service';

@Component({
  selector: 'app-document-type-search',
  templateUrl: './document-type-search.component.html',
  styleUrls: ['./document-type-search.component.css'],
  providers: [DocumentTypeSearchService],
})
export class DocumentTypeSearchComponent implements OnInit, OnChanges {
  /**
   * Document type search term
   * @type {string}
   */
  documentTypeSearchTerm: string;

  /**
   * Indicates if include search result item in output
   */
  @Input() include_item: boolean = false;

  /**
   * Document type id for initial selection
   */
  @Input() documentTypeId: number | undefined;

  /**
   * Indicates if input size should be small based on bootstrap form-control class
   */
  @Input() small_input: boolean = false;

  /**
   * Indicates if search should be allowed
   */
  @Input() editable: boolean = true;

  /**
   * Get placeholder from parent component and overrides the default in HTML
   */
  @Input() placeholder: string;

  /**
   * Output contact id on document type selection
   * @param {EventEmitter<number> = new EventEmitter(} ) document_type_id variable name
   */
  @Output() document_type_id: EventEmitter<number> = new EventEmitter();

  /**
   * Indicates if document type selection is only to be sent as output and not show in the HTML
   */
  @Input() select_only: boolean = false;

  /**
   * Output selected document type item from the search results
   * @param {EventEmitter<any>    = new EventEmitter(} ) document_type variable name
   */
  @Output() document_type: EventEmitter<any> = new EventEmitter();

  /**
   * Outputs if document type is to be cleared
   * @param {EventEmitter<any>    = new EventEmitter(} ) clearDocumentType variable name
   */
  @Output() clearDocumentType: EventEmitter<any> = new EventEmitter();

  /**
   * Constructor
   * @param {DocumentTypeSearchService} private documentTypeSearchService Service to access document types controller for search related actions
   */
  constructor(private documentTypeSearchService: DocumentTypeSearchService) {}

  // Component lifecycle events

  /**
   * Called on component initialization
   */
  ngOnInit() {}

  /**
   * Called on component variable changes
   * @param {any} changes Angular changes object with variables changed and current value
   */
  ngOnChanges(changes: any) {
    if (changes.documentTypeId && changes.documentTypeId.currentValue && !this.select_only)
      this.documentTypeSearchService.getDocumentTypeInfo(this.documentTypeId!).then((response_json) => {
        this.documentTypeSearchTerm = response_json.label;
      });
    else if (this.select_only) this.documentTypeSearchTerm = '';
  }

  /**
   * Called to clear selected document type and output to parent component
   */
  clearSelectedDocumentType(): void {
    this.documentTypeId = undefined;
    this.documentTypeSearchTerm = '';
    this.clearDocumentType.emit('clearDocumentType');
  }

  /**
   * Called when document type search result item is selected
   * @param {any} item Search result item as per AutoComplete format of label and value fields
   */
  documentTypeSearchOnSelect(item: any): void {
    if (this.include_item) this.documentTypeId = item.id;
    else this.documentTypeId = item;
    if (this.select_only) {
      let scope = this;
      this.document_type.emit(item);
      window.setTimeout(function () {
        scope.documentTypeSearchTerm = '';
      }, 100);
    } else if (this.include_item) {
      this.document_type.emit(item);
      this.document_type_id.emit(Number(item.id));
    } else this.document_type_id.emit(Number(item));
  }
}
